import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import * as API from "./api";
import * as Actions from "./actions";

function* loadCServicesHandler() {
  try {
    const { response } = yield call(API.loadServices);
    yield put(Actions.loadServices.success(response));
  } catch (error) {
    yield put(Actions.loadServices.failure(error));
  }
}

function* watchLoadServices() {
  yield takeLatest(Actions.LOAD_SERVICES.REQUEST, loadCServicesHandler);
}

export default function* servicesSagas() {
  yield all([fork(watchLoadServices)]);
}
